// extracted by mini-css-extract-plugin
export default {"emptyPage":"ClientPortal_emptyPage__3J+c9","emptyPage_title":"ClientPortal_emptyPage_title__iLFk-","emptyPage_help":"ClientPortal_emptyPage_help__GXzIV"};